import { useParams, useSearchParams, Link } from "react-router-dom";
import type { MeetingMode } from "../lib/api";

function getMeetingModeMessage(mode: MeetingMode | null): string | null {
  if (mode === "video") {
    return "A video call link will be emailed to you before your appointment.";
  }
  if (mode === "phone") {
    return "We'll call you at the scheduled time.";
  }
  // in_person or missing
  return "See you there!";
}

export default function Success() {
  const { slug } = useParams<{ slug: string }>();
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");
  const serviceName = searchParams.get("service");
  const startsAt = searchParams.get("starts_at");
  const staffName = searchParams.get("staff");
  const meetingModeParam = searchParams.get("meeting_mode") as MeetingMode | null;

  const formattedDate = startsAt
    ? new Date(startsAt).toLocaleString(undefined, {
        weekday: "long",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
      })
    : null;

  const modeMessage = getMeetingModeMessage(meetingModeParam);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Success icon */}
        <div className="text-center">
          <div
            className="w-20 h-20 rounded-full flex items-center justify-center text-4xl mx-auto mb-4"
            style={{ backgroundColor: "var(--color-accent, #6366f1)", color: "white" }}
          >
            &#10003;
          </div>
          <h1 className="text-2xl font-bold text-gray-900">You&apos;re booked!</h1>
          <p className="mt-2 text-gray-500">
            Your appointment has been confirmed.
          </p>
          {modeMessage && (
            <p className="mt-1 text-sm text-gray-500">{modeMessage}</p>
          )}
        </div>

        {/* Booking summary */}
        <div className="mt-8 bg-white border border-gray-200 rounded-xl divide-y divide-gray-100">
          {serviceName && (
            <div className="p-4">
              <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">
                Service
              </p>
              <p className="font-medium text-gray-900">{serviceName}</p>
            </div>
          )}
          {formattedDate && (
            <div className="p-4">
              <p className="text-xs text-gray-500 uppercase tracking-wide mb-1">
                Date &amp; Time
              </p>
              <p className="font-medium text-gray-900">{formattedDate}</p>
              {staffName && (
                <p className="text-sm text-gray-500 mt-0.5">with {staffName}</p>
              )}
            </div>
          )}
        </div>

        {/* Actions */}
        <div className="mt-6 flex flex-col gap-3">
          {token && slug && (
            <Link
              to={`/${slug}/cancel/${token}`}
              className="block text-center py-2.5 px-4 rounded-lg border border-gray-300 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
            >
              Need to cancel?
            </Link>
          )}
          <Link
            to={`/${slug}`}
            className="block text-center py-2.5 px-4 rounded-lg btn-accent text-sm font-medium"
          >
            Book another appointment
          </Link>
        </div>
      </div>
    </div>
  );
}
